import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { HorseGroupMember } from './horse-group-member';
export { HorseGroupMember };
import { horseGroupMemberSchema } from '@schemas/business-objects/horse-group-member';
import { HorseFormGroup } from './horse-form-group';
import { HorseGroupFormGroup } from './horse-group-form-group';

export class HorseGroupMemberFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    legacyId: SchemaFormControl;
    horseGroupId: SchemaFormControl;
    horseGroup: HorseGroupFormGroup;
    horseId: SchemaFormControl;
    horse: HorseFormGroup;
  };

  declare value: Partial<HorseGroupMember>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(horseGroupMemberSchema, HorseGroupMember, data, options);
  }

  get object(): HorseGroupMember {
    return new HorseGroupMember(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'horseGroup':
        return new HorseGroupFormGroup();
      case 'horse':
        return new HorseFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<HorseGroupMember[]> {
    return HorseGroupMember.find(filter);
  }

  static async findOne(filter?: any): Promise<HorseGroupMember | null> {
    return HorseGroupMember.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<HorseGroupMember> {
    return HorseGroupMember.findById(id, filter);
  }

  static async create(
    data: Partial<HorseGroupMember>,
  ): Promise<HorseGroupMember> {
    return HorseGroupMember.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<HorseGroupMember>,
  ): Promise<HorseGroupMember> {
    return HorseGroupMember.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return HorseGroupMember.deleteById(id);
  }
}

export class HorseGroupMemberFormArray extends PersistedFormArray {
  declare controls: HorseGroupMemberFormGroup[];

  readonly entityName = 'HorseGroupMember' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(horseGroupMemberSchema, HorseGroupMember, options);
  }

  protected override createItemGroup() {
    return new HorseGroupMemberFormGroup();
  }

  get array(): HorseGroupMember[] {
    return this.controls.map(
      (group: HorseGroupMemberFormGroup) => group.object,
    );
  }
}

export class HorseGroupMemberPersistedArray extends PersistedArray<HorseGroupMember> {
  readonly entityName = 'HorseGroupMember' as const;

  constructor(options?: PersistedArrayOptions) {
    super(HorseGroupMember, options);
  }
}
